import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isObject } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PrintHelper from 'print-helper-lib';
import { values } from 'lodash';
import { SubHeading } from 'web-ui-components/lib/typography/headings';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Alert } from 'web-ui-components/lib/molecules/nbas';
import { TabNav, TabPanel } from 'payments-lib/lib/sharedComponents';
import { Loader } from 'web-ui-components/lib/organisms/modals';
import { getBankId, getIsLCV } from '../../states/session/selectors';
import { getCustomerId } from '../../states/user/selectors';

import { closeAlert, handleLoad } from '../../states/page/actions';
import {
	selectAwaitingAuthTab,
	selectToEdit,
	updateMyPaymentsSortColumn,
	updateOtherUserPaymentsSortColumn,
} from '../../states/payments/actions';
import {
	getActiveAwaitingAuthTab,
	getMyPaymentsToAuthoriseCount,
	getOtherUserPaymentsToAuthoriseCount,
} from '../../states/payments/builders';
import {
	getShowExpiredPayments,
	getMyPaymentsSortColumn,
	getOtherUserPaymentsSortColumn,
} from '../../states/payments/selectors';
import listingContent, { contentPropTypes } from './PaymentAuthListings.content';
import withContent from '../../containers/withContent';
import withScrollTop from '../../containers/withScrollTop';
import MyPaymentsToAuth from './MyPaymentsToAuth';
import OtherUserPaymentsToAuthorise from './OtherUserPaymentsToAuth';
import { getAccountsWithPaymentReadAction, getAccountsWithTransactionRead } from '../../states/accounts/selectors';
import accountPropTypes from '../../states/accounts/propTypes';
import ExpiredPayments from './ExpiredPayments';
import { hasApiCallInProgress } from '../../states/api/selectors';
import {
	fileUploadReviewed,
	hasFileUploadError,
	hasErrorDeadline,
	fileUploadErrorMessage,
} from '../../states/page/selectors';
import { getCustomerCapabilities } from '../../states/capabilities/actions';
import { getBankOrBrandId } from '../../states/envConfig/selectors';

const mapState = (state) => ({
	activeAwaitingAuthTab: getActiveAwaitingAuthTab(state),
	userOnlyAccounts: getAccountsWithPaymentReadAction(state),
	allAccounts: getAccountsWithTransactionRead(state),
	myPaymentsToAuthoriseCount: getMyPaymentsToAuthoriseCount(state),
	otherUserPaymentsToAuthoriseCount: getOtherUserPaymentsToAuthoriseCount(state),
	showExpiredPayments: getShowExpiredPayments(state),
	hasApiCallInProgress: hasApiCallInProgress(state),
	bankId: getBankId(state),
	brandId: getBankOrBrandId(state),
	userId: getCustomerId(state),
	fileUploadReviewed: fileUploadReviewed(state),
	hasFileUploadError: hasFileUploadError(state),
	fileErrorDeadline: hasErrorDeadline(state),
	fileUploadErrorMessage: fileUploadErrorMessage(state),
	isLCV: getIsLCV(state),
	myPaymentSortColumn: getMyPaymentsSortColumn(state),
	otherPaymentSortColumn: getOtherUserPaymentsSortColumn(state),
});
const mapDispatch = (dispatch) => ({
	handleLoad: () => dispatch(handleLoad()),
	handleSelectTab: (id) => dispatch(selectAwaitingAuthTab(id)),
	handleEdit: (id) => dispatch(selectToEdit(id)),
	closeFileReviewedAlert: (value) => dispatch(closeAlert(value)),
	getCustomerCapabilities: (bankId, customerId) => dispatch(getCustomerCapabilities(bankId, customerId)),
	updateMySortColumn: (sortColumn) => {
		dispatch(updateMyPaymentsSortColumn(sortColumn));
	},
	updateOtherSortColumn: (sortColumn) => {
		dispatch(updateOtherUserPaymentsSortColumn(sortColumn));
	},
});

export const PreferredMySortColumn = 'PreferredMySortColumn';
export const PreferredOtherSortColumn = 'PreferredOtherSortColumn';

const PaymentAuthListings = class extends Component {
	constructor(props) {
		super(props);
		this.handleRefreshPage = this.handleRefreshPage.bind(this);
		this.storeSortPreferences = this.storeSortPreferences.bind(this);
	}

	componentDidMount() {
		const { handleLoad, updateMySortColumn, updateOtherSortColumn } = this.props;

		let preferredMySortColumn;
		let preferredOtherSortColumn;

		handleLoad();

		try {
			if (window.localStorage) {
				const preferredMySortColumnRaw = window.localStorage.getItem(PreferredMySortColumn);
				const preferredOtherSortColumnRaw = window.localStorage.getItem(PreferredOtherSortColumn);

				if (preferredMySortColumnRaw) {
					preferredMySortColumn = JSON.parse(preferredMySortColumnRaw);
				}

				if (preferredOtherSortColumnRaw) {
					preferredOtherSortColumn = JSON.parse(window.localStorage.getItem(PreferredOtherSortColumn));
				}

				if (preferredMySortColumn && isObject(preferredMySortColumn)) {
					updateMySortColumn(preferredMySortColumn);
				}

				if (preferredOtherSortColumn && isObject(preferredOtherSortColumn)) {
					updateOtherSortColumn(preferredOtherSortColumn);
				}
			}
		} catch (error) {
			console.error(error); // eslint-disable-line no-console
		}
	}

	// eslint-disable-next-line class-methods-use-this
	storeSortPreferences(authColumnType, sortColumn) {
		try {
			if (window.localStorage) {
				if (authColumnType === PreferredMySortColumn) {
					localStorage.setItem(PreferredMySortColumn, JSON.stringify(sortColumn));
				} else {
					localStorage.setItem(PreferredOtherSortColumn, JSON.stringify(sortColumn));
				}
			}
		} catch (error) {
			console.error(error); // eslint-disable-line no-console
		}
	}

	handleRefreshPage() {
		const { handleLoad, userOnlyAccounts, allAccounts, handleRefresh, getCustomerCapabilities, bankId, userId } =
			this.props;
		getCustomerCapabilities(bankId, userId);
		handleLoad(userOnlyAccounts, allAccounts);
		if (handleRefresh) {
			handleRefresh();
		}
	}

	buildTabs() {
		const { byYouTabLabel, byOthersTabLabel } = this.props.content;
		const { myPaymentsToAuthoriseCount, otherUserPaymentsToAuthoriseCount } = this.props;
		const tabs = {
			you: {
				id: 'you',
				title: byYouTabLabel,
				notification: myPaymentsToAuthoriseCount.toString(),
			},
			others: {
				id: 'others',
				title: byOthersTabLabel,
				notification: otherUserPaymentsToAuthoriseCount.toString(),
			},
		};
		tabs[this.props.activeAwaitingAuthTab].isActive = true;

		return tabs;
	}

	showAlert() {
		const {
			content,
			fileUploadReviewed,
			closeFileReviewedAlert,
			hasFileUploadError,
			fileErrorDeadline,
			fileUploadErrorMessage,
		} = this.props;
		const { twoStepSuccess } = content;
		if (fileUploadReviewed || (hasFileUploadError && !fileErrorDeadline)) {
			const alertType = fileUploadReviewed ? 'tip' : 'warning';
			const twoStepMessage = fileUploadReviewed ? twoStepSuccess : fileUploadErrorMessage;
			return (
				<Alert type={`${alertType}`} onClose={() => closeFileReviewedAlert(false)}>
					<p>{twoStepMessage}</p>
				</Alert>
			);
		}
		return '';
	}

	render() {
		const { content, showExpiredPayments, hasApiCallInProgress, handleEdit, brandId, handleEditById } = this.props;
		const { awaitingAuthTitle, refreshButton, noPaymentsByOthers, noPaymentsByMe } = content;
		const tabs = this.buildTabs();
		return (
			<div>
				{showExpiredPayments && <ExpiredPayments {...content} />}
				{this.showAlert()}
				<div className="u-flex u-flex-justify-content-space-between">
					<SubHeading>{awaitingAuthTitle}</SubHeading>
					<Button id="refreshBtn" display="secondary" onClick={this.handleRefreshPage} className="u-margin-bottom-1">
						{refreshButton} <Icon iconType="CycleSolidLarge" className="c-a-button__icon" />
					</Button>
				</div>

				<TabNav isSkeuomorphic tabs={values(tabs)} handleSelectTab={this.props.handleSelectTab} />
				<PrintHelper className="web-ui-components" brandId={brandId} showPrintTopIcon showPrintBottomIcon={false}>
					<TabPanel {...tabs.you}>
						<MyPaymentsToAuth
							noPaymentsMsg={noPaymentsByMe}
							handleEdit={handleEdit}
							refresh={this.handleRefreshPage}
							handleEditById={handleEditById}
							storeSortPreferences={this.storeSortPreferences}
						/>
					</TabPanel>
					<TabPanel {...tabs.others}>
						<OtherUserPaymentsToAuthorise
							noPaymentsMsg={noPaymentsByOthers}
							handleEdit={handleEdit}
							refresh={this.handleRefreshPage}
							handleEditById={handleEditById}
							storeSortPreferences={this.storeSortPreferences}
						/>
					</TabPanel>
				</PrintHelper>
				<Loader isOpen={hasApiCallInProgress} />
			</div>
		);
	}
};

PaymentAuthListings.propTypes = {
	handleLoad: PropTypes.func.isRequired,
	handleRefresh: PropTypes.func,
	content: PropTypes.shape(contentPropTypes),
	activeAwaitingAuthTab: PropTypes.string.isRequired,
	handleSelectTab: PropTypes.func,
	myPaymentsToAuthorise: PropTypes.arrayOf(PropTypes.shape({})),
	userOnlyAccounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes)),
	allAccounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes)),
	myPaymentsToAuthoriseCount: PropTypes.number,
	otherUserPaymentsToAuthoriseCount: PropTypes.number,
	handleEdit: PropTypes.func,
	showExpiredPayments: PropTypes.bool,
	hasApiCallInProgress: PropTypes.bool.isRequired,
	bankId: PropTypes.string.isRequired,
	brandId: PropTypes.string.isRequired,
	getCustomerCapabilities: PropTypes.func.isRequired,
	userId: PropTypes.string.isRequired,
	handleEditById: PropTypes.func,
	fileUploadReviewed: PropTypes.bool,
	closeFileReviewedAlert: PropTypes.func,
	hasFileUploadError: PropTypes.bool,
	fileErrorDeadline: PropTypes.bool,
	fileUploadErrorMessage: PropTypes.string,
	updateMySortColumn: PropTypes.func.isRequired,
	updateOtherSortColumn: PropTypes.func.isRequired,
	myPaymentSortColumn: PropTypes.shape({
		sortDirection: PropTypes.string,
		id: PropTypes.string,
	}).isRequired,
	otherPaymentSortColumn: PropTypes.shape({
		sortDirection: PropTypes.string,
		id: PropTypes.string,
	}).isRequired,
};

export default compose(
	connect(mapState, mapDispatch),
	withContent({ content: listingContent }),
	withScrollTop()
)(PaymentAuthListings);
